export function normalizeSearch(text) {
  return String(text ?? '').trim().toLowerCase();
}

/** True if query is empty or any value contains the query (case-insensitive). */
export function matchesGlobalSearch(query, values) {
  const q = normalizeSearch(query);
  if (!q) return true;
  return values.some((v) => normalizeSearch(v).includes(q));
}
